import { getIsMultiProduct } from "../../../../src/service/SupplierService"
import { useQuery } from "react-query"

export default function useIsMultiProducts(token, supplierId, apiUrl) {
  const enabledIsMultiProduct = supplierId !== undefined && !!supplierId && supplierId.length !== 0

  const { data: isMultiProduct } = useQuery({
    queryKey: ["isMultiProduct", supplierId],
    queryFn: () => getIsMultiProduct(token, supplierId, apiUrl),
    enabled: enabledIsMultiProduct,
    refetchOnWindowFocus: false
  })
  return isMultiProduct
}
